import request from '@/utils/request'

export function login(res) {
  return request({
    url: '/ajax/user/login',
    method: 'post',
    data: {
      username: res.username,
      password: res.password,
      sso: res.sso,
      sig: res.sig
    }
  })
}

export function getInfo() {
  return request({
    url: '/ajax/user',
    method: 'get'
  })
}

export function getUserName() {
  return request({
    url: '/admin/info',
    method: 'get'
  })
}


export function postRegist(res) {
  return request({
    url: '/ajax/user/regist',
    method: 'post',
    data: {
      username: res.username,
      password: res.password,
      phone_nbr: res.phone_nbr,
      vcode: res.vcode,
      sso: res.sso,
      sig: res.sig
    }
  })
}

export function postSendsms(res) {
  return request({
    url: '/ajax/user/sendsms',
    method: 'post',
    data: {
      phone_nbr: res.phone_nbr,
      captcha_id: res.captcha_id,
      captcha_value: res.captcha_value
    }
  })
}



export function retrievePassword(res) {
  return request({
    url: '/ajax/user/chpassauth',
    method: 'post',
    data: {
      phone_nbr: res.phone_nbr,
      vcode: res.vcode
    }
  })
}

export function modifyPassword(res) {
  return request({
    url: '/ajax/user/chpass',
    method: 'post',
    data: {
      new_pass: res.password
    }
  })
}



export function getVerification() {
  return request({
    url: '/ajax/user/get-captcha',
    method: 'get'
  })
}

export function getIsVerification() {
  return request({
    url: '/ajax/configs',
    method: 'get'
  })
}

export function logout(user_id) {
  return request({
    url: '/ajax/user/logout',
    method: 'post',
    data: {
      user_id
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js